import { Injectable } from '@angular/core';
import { BaseResolver } from '@app/app.resolver';
import { ModelFactory } from '@app/models/core/model-factory';
import { CustomReportQuery } from '@app/models/reporting/custom-report-query.model';

@Injectable()
export class ReportingResolver extends BaseResolver {
    protected modelFactory: ModelFactory = new ModelFactory([
        {
            className: 'customReportQuery',
            production: {
                find: (id: number) => {
                    return CustomReportQuery.with(['filters']).param('custom_report_type', 'employee').find(id);
                },
            },
        },
    ]);
}
